import {Card} from "@material-ui/core";
import {EditProps} from "react-admin";
import {DefaultEdit} from "../../components/DefaultEdit";
import {CustomerOrderForm} from "./CustomerOrderForm";

export const CustomerOrderEdit = (props: EditProps) => {
  return (
    <DefaultEdit {...props} component={Card}>
      <CustomerOrderForm />
    </DefaultEdit>
  );
};
